import CreateProjectBasedLearningView from "@features/tools/view/project-based-learning-view/create-project-based-learning-view";

const CreateProjectBasedLearning = () => {
  return <CreateProjectBasedLearningView />;
};

export default CreateProjectBasedLearning;
